import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const priestBeggen: NarratorNPC = {
  id: 'priest-beggen',
  name: 'Priest',
  dialog: dialog,
};
